$(document).ready(function () {
    $('.js_partners').each((i, el) => {
        new Swiper(el, {
            enabled: false,
            breakpoints: {
                568: {
                    enabled: true,
                    slidesPerView: 'auto',
                    freeMode: {
                        enabled: true,
                        sticky: true,
                    }
                },
                1440: {
                    slidesPerView: 7,
                    freeMode: {
                        enabled: false
                    }
                }
            },
            modules: [SwiperModes.FreeMode]
        })
    })
})

$(document).on('mouseenter', '.js_partners__links', function (e) {
    if (!$(this).hasClass('animate')) {
        $(this).addClass('animate')
        let button = $(this).find('.js_partners__title')
        let list = $(this).find('.js_partners__list')
        button.addClass('active')
        list.slideDown(300, 'linear')
        setTimeout(() => {
            $(this).removeClass('animate')
        }, 300)
    }
})

$(document).on('mouseleave', '.js_partners__links', function (e) {
    let button = $(this).find('.js_partners__title')
    let list = $(this).find('.js_partners__list')
    list.stop()
    button.removeClass('active')
    list.slideUp(300, 'linear')
})